import { useCallback, useEffect, useRef } from 'react';
import type { ChatMessage } from './types';

// Markiert den offenen Chat als gelesen, bis zur neuesten angezeigten Nachricht.
// Nur solange die Seite sichtbar ist; wird sie wieder sichtbar, wird nachgeholt.
// Es wird nur gesendet, wenn sich der Stand vorwärts bewegt (sonst Endlosschleife mit dem Live-Ereignis).
export function useMarkRead(key: string, messages: ChatMessage[] | undefined, post: (until: string) => Promise<unknown>) {
  const newest = messages?.[messages.length - 1]?.at;
  const marked = useRef({ key: '', at: '' });
  const postRef = useRef(post);
  postRef.current = post;

  const run = useCallback(() => {
    if (!newest || document.visibilityState !== 'visible') return;
    const m = marked.current;
    if (m.key === key && m.at >= newest) return;
    marked.current = { key, at: newest };
    postRef.current(newest).catch(() => {
      marked.current = { key: '', at: '' };
    });
  }, [key, newest]);

  useEffect(() => {
    run();
  }, [run]);
  useEffect(() => {
    document.addEventListener('visibilitychange', run);
    return () => document.removeEventListener('visibilitychange', run);
  }, [run]);
}
